import { useApp } from '@/hooks/useApp'
import { Product } from 'BrokerTsLib/src/enums'
import { FormSection, FormSectionBody, FormSectionDescription, FormSectionHeader, FormSectionTitle } from '../../components/FormSection'
import { NewInsuranceVariant } from './NewInsuranceVariant'

export const GetNewInsuranceVariantWrapperLabel = (product: Product) => {
  return product == Product.LiabilityInsurance
    ? 'Přidat další pojišťovnu'
    : 'Přidat další variantu pojištění'
}

export const NewInsuranceVariantWrapper = () => {
  const { product } = useApp()
  const label = GetNewInsuranceVariantWrapperLabel(product!)

  return (
    <FormSection>
      <FormSectionHeader>
        <FormSectionTitle>{label}</FormSectionTitle>

        <FormSectionDescription>
          Zadejte parametry pro vytvoření další varianty pojištění.
        </FormSectionDescription>
      </FormSectionHeader>

      <FormSectionBody>
        <NewInsuranceVariant />
      </FormSectionBody>
    </FormSection>
  )
}